// LLM generated - Model Claude 4 Sonnet
import { BrandLogo } from '../components/BrandLogo';
import { HeaderTitle } from '../components/HeaderTitle';
import { HeaderSubtitle } from '../components/HeaderSubtitle';
import { BrandLogos } from '../components/BrandLogos';
import type { titleStyles } from '~/domains/design-system/Title';

type SplashRendererProps = {
  title: string;
  brandText: string;
  logoSize: number;
  centered: boolean;
  titleVariant: keyof typeof titleStyles;
  isLogoVisible: boolean;
  classes: {
    IconCentered: string;
    Icon: string;
    LoginHeaderTitle: string;
    credentialsContainer: string;
    logosContainer: string;
  };
};

export function SplashRenderer({
  title,
  brandText,
  logoSize,
  centered,
  titleVariant,
  isLogoVisible,
  classes,
}: SplashRendererProps) {
  return (
    <>
      {isLogoVisible && (
        <BrandLogo size={logoSize} className={centered ? classes.IconCentered : classes.Icon} />
      )}
      <HeaderTitle title={title} variant={titleVariant} className={classes.LoginHeaderTitle} />
      <div className={classes.credentialsContainer}>
        <HeaderSubtitle text={brandText} />
        <BrandLogos className={classes.logosContainer} />
      </div>
    </>
  );
}
